import { GetStaticPropsContext } from 'next'

import { MenuData } from '../models/header'

export const footerData: MenuData = {
  menu: {
    id: 'footer-menu-1',
    items: [
      {
        id: 'about',
        name: 'About',
        translation: null,
        page: null,
        category: null,
        collection: null,
        url: '/about/our-story',
        children: [
          {
            id: 'our-story',
            name: 'Our Story',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/about/our-story',
            children: [],
          },
          {
            id: 'team',
            name: 'Meet Our Team',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/about/our-story',
            children: [],
          },
        ],
      },
      {
        id: 'explore',
        name: 'Explore',
        translation: null,
        page: null,
        category: {
          id: 'explore-shop',
          slug: 'shop',
          url: '/shop',
        },
        collection: null,
        url: null,
        children: [
          {
            id: 'shop',
            name: 'Shop',
            translation: null,
            page: null,
            category: {
              id: 'shop',
              slug: 'shop',
              url: '/shop',
            },
            collection: null,
            url: null,
            children: [],
          },
          {
            id: 'Library',
            name: 'Library',
            translation: null,
            page: null,
            category: {
              id: 'library',
              slug: 'library',
              url: '/library',
            },
            collection: null,
            url: null,
            children: [],
          },
          {
            id: 'blog',
            name: 'Blog',
            translation: null,
            page: null,
            category: {
              id: 'blog',
              slug: 'blog',
              url: '/blog',
            },
            collection: null,
            url: null,
            children: [],
          },
          {
            id: 'compare',
            name: 'Compare',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/compare',
            children: [],
          },
        ],
      },
      {
        id: 'help',
        name: 'Help',
        translation: null,
        page: null,
        category: null,
        collection: null,
        url: '/help',
        children: [
          {
            id: 'guides',
            name: 'FAQ',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/help/faq',
            children: [],
          },
          {
            id: 'contact',
            name: 'Contact Us',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/help/contact',
            children: [],
          },
          // {
          //   id: 'how-it-works',
          //   name: 'How It Works',
          //   translation: null,
          //   page: null,
          //   category: null,
          //   collection: null,
          //   url: '/how-it-works',
          //   children: [],
          // },
          {
            id: 'terms',
            name: 'Terms of Service',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/help/terms',
            children: [],
          },
          {
            id: 'privacy',
            name: 'Privacy Policy',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/help/privacy',
            children: [],
          },
          {
            id: 'refund-policy',
            name: 'Refund Policy',
            translation: null,
            page: null,
            category: null,
            collection: null,
            url: '/help/refund-policy',
            children: [],
          },
        ],
      },
    ],
  },
}

export const footerQuery = async (_context: GetStaticPropsContext) => {
  return footerData
}